import React, { useState, useEffect } from "react";
import "./badge.css";

export const ExpandableBadge = ({ primaryText, secondaryText }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExpanded(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const state1Text = primaryText;
  const state2Text = secondaryText;

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="badge-container">
      <div
        className={`expandable-badge ${isExpanded ? "expanded" : "collapsed"}`}
        onClick={handleClick}
      >
        <span className="badge-text">
          {isExpanded ? state2Text : state1Text}
        </span>
      </div>
    </div>
  );
};
